import "./auth.scss";
import React from "react";
import CommonAuthComponent from "./CommonAuthComponent";

export default function SignInPage() {
    return <CommonAuthComponent variant="signin" />;
}
